import type { GrowthOverviewGranularity, GrowthOverviewMetric } from "./const";

export const GrowthOverviewLevel = {
    Industries: "industries",
    SubIndustries: "subIndustries",
    Domains: "domains",
} as const;

export type GrowthOverviewLevel = (typeof GrowthOverviewLevel)[keyof typeof GrowthOverviewLevel];

export type TGrowthOverviewSortDirection = "asc" | "desc";

export interface IGrowthOverviewSort {
    field: string;
    direction: TGrowthOverviewSortDirection;
}

export const GROWTH_OVERVIEW_NAME_SORT_FIELD = "name";
export const GROWTH_OVERVIEW_SUMMARY_SORT_FIELD = "summary";

export const DEFAULT_GROWTH_OVERVIEW_SORT: IGrowthOverviewSort = {
    field: GROWTH_OVERVIEW_SUMMARY_SORT_FIELD,
    direction: "desc",
};

export interface IGrowthOverviewPeriodCell {
    key: string;
    label: string;
    date: string;
    value: number | null;
    pop: number | null;
    isIncomplete?: boolean;
}

export type TGrowthOverviewRowType = "industry" | "sub-industry" | "domain";

export interface IGrowthOverviewTableRow {
    id: string;
    rowType: TGrowthOverviewRowType;
    category: string;
    displayName: string;
    domain?: string;
    favicon?: string;
    summaryVisits: number | null;
    summaryUnique: number | null;
    visitsPeriods: IGrowthOverviewPeriodCell[];
    uniquePeriods: IGrowthOverviewPeriodCell[];
    children?: IGrowthOverviewTableRow[];
    domainCount?: number;
    totalDomainCount?: number;
    totalSubIndustryCount?: number;
    childrenLoaded?: boolean;
}

export interface IGrowthOverviewContextValue {
    metric: GrowthOverviewMetric;
    granularity: GrowthOverviewGranularity;
    searchTerm: string;
    debouncedSearchTerm: string;
    isSearchPending: boolean;
    setMetric: (metric: GrowthOverviewMetric) => void;
    setGranularity: (granularity: GrowthOverviewGranularity) => void;
    setSearchTerm: (term: string) => void;
    isQuarterlyEnabled: boolean;
}
